import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import {MatBadgeModule} from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatDialogModule  } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTabsModule } from '@angular/material/tabs';
import { MatRadioModule } from '@angular/material/radio';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatSortModule} from '@angular/material/sort';
import {MatTableModule} from '@angular/material/table';
import {MatPaginatorModule} from '@angular/material/paginator';
import { MatCardModule } from '@angular/material/card';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {MatToolbarModule} from '@angular/material/toolbar';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatButtonToggleModule} from '@angular/material/button-toggle';
import {MatSidenavModule} from '@angular/material/sidenav';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {MatDividerModule} from '@angular/material/divider';
import {ScrollingModule} from '@angular/cdk/scrolling';

import { FlexLayoutModule } from '@angular/flex-layout';

// TRANSLATE
import { TranslateModule } from '@ngx-translate/core';

// SERVICIO AUTORIZACION E INTERCEPTION DE TOKEN
import { AuthGuard } from 'app/auth/auth.guard';

import { GoFlowComponent } from './go-flow/go-flow.component';
import { TrustIndexComponent } from './trustindex/trustindex.component';
import { Results5Component } from './results5.0/results5.component';
import { Version5Component } from 'app/main/pagina/productos/actionGO/version5/version5.component';
import { TableauComponent } from './trustindex/tableau/tableau.component';
import { ResultadosCGO2Component } from './trustindex/resultadosCGO2/resultadosCGO2.component';
import { Resultados4allComponent } from './resultados4all/resultados4all.component';
// import { CertificarComponent } from './trustindex/secciones/certificar/certificar.component';
// import { MedirComponent } from './trustindex/secciones/medir/medir.component';
// import { PulsecheckComponent } from './trustindex/secciones/pulse-check/pulse-check.component';
// import { TablaComponent } from './trustindex/secciones/tabla/tabla.component';
import { ChartsModule } from 'ng2-charts';
import { GraficabarraComponent } from './resultados4all/graficabarra/graficabarra.component';
import { ForallResultadosViejosComponent } from './forall-resultados-viejos/forall-resultados-viejos.component';
import { CovidComponent } from './covid/covid.component';
import { VideosTutorialesComponent } from './videos-tutoriales/videos-tutoriales.component';
import { DimensionDiscoveryComponent } from './videos-tutoriales/dimension-discovery/dimension-discovery.component';
import { DomographicFinderComponent } from './videos-tutoriales/domographic-finder/domographic-finder.component';
import { LeadersComponent } from './videos-tutoriales/leaders/leaders.component';
import { CommentMinerComponent } from './videos-tutoriales/comment-miner/comment-miner.component';
import { ExecutiveSummaryComponent } from './videos-tutoriales/executive-summary/executive-summary.component';
import { CorrelationsComponent } from './videos-tutoriales/correlations/correlations.component';


const rutas: Routes = [
    // trust index
    {
        path     : 'results/trust_index',
        component: TrustIndexComponent,
        canActivate: [AuthGuard]
    },
    {
        path     : 'results/trust_index/certificar',
        component: TableauComponent,
        data : {producto : 'CERTIFICAR'},
        canActivate: [AuthGuard]
    },
    {
        path     : 'results/trust_index/medir',
        component: TableauComponent,
        data : {producto : 'MEDIR'},
        canActivate: [AuthGuard]
    },
    {
        path     : 'results/trust_index/innotion',
        component: TableauComponent,
        data : {producto : 'MEDIR'},
        canActivate: [AuthGuard]
    },
    {
        path     : 'results/trust_index/pulse-check',
        component: TableauComponent,
        data : {producto : 'PULSE'},
        canActivate: [AuthGuard]
    },
    {
        path     : 'results/legacy',
        component: ResultadosCGO2Component,
        data : {producto : 'legacy'},
        canActivate: [AuthGuard]
    },
    {
        path     : 'results/4all',
        component: Resultados4allComponent,
        data : {producto : '4all'},
        canActivate: [AuthGuard]
    },
    {
        path     : 'results/forallviejos',
        component: ForallResultadosViejosComponent,
        data : {producto : 'FORALL_VIEJOS'},
        canActivate: [AuthGuard]
    },
    {
        path     : 'results/covid',
        component: CovidComponent,
        canActivate: [AuthGuard]
    },{
        path : 'results/results5.0',
        component: Results5Component,
        canActivate: [AuthGuard]
    },{
        path : 'results/actionGO',
        component: Version5Component,
        canActivate: [AuthGuard]
    },
    {
        path     : 'results/4all/:tipoProducto/:idProducto/:empresaId/:token',
        component: Resultados4allComponent,
    },{
        path : 'results/goFlow',
        component: GoFlowComponent,
        canActivate: [AuthGuard]
    },
];

@NgModule({
  declarations: [
    TrustIndexComponent,
    Results5Component,
    TableauComponent,
    ResultadosCGO2Component,
    Resultados4allComponent,
    GraficabarraComponent,
    ForallResultadosViejosComponent,
    CovidComponent,
    VideosTutorialesComponent,
    DimensionDiscoveryComponent,
    DomographicFinderComponent,
    LeadersComponent,
    CommentMinerComponent,
    ExecutiveSummaryComponent,
    CorrelationsComponent,
    GoFlowComponent,
    // CertificarComponent,
    // MedirComponent,
    // PulsecheckComponent,
    // TablaComponent
  ],
  imports: [
    CommonModule,
    RouterModule.forChild(rutas),
    TranslateModule,
    MatBadgeModule,
    MatButtonModule,
    MatCheckboxModule,
    MatChipsModule,
    MatDialogModule ,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatSelectModule,
    MatStepperModule,
    MatTabsModule,
    BrowserAnimationsModule,
    MatRadioModule,
    MatDatepickerModule,
    MatSortModule,
    MatTableModule,
    MatPaginatorModule,
    MatCardModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    FlexLayoutModule,
    MatToolbarModule,
    MatExpansionModule,
    ChartsModule,
    MatButtonToggleModule,
    MatSidenavModule,
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    MatDividerModule,
    ScrollingModule,
  ]
})
export class ResultdadosModule { }
